import { Button } from '@massilia/ui'
import { CopyPlus } from 'lucide-react'

import type { SimilarRequest } from './similar-request'

export function RequestSimilarButton({ request }: { request: SimilarRequest }) {
  if (request.isSuccess) {
    return (
      <p className="text-sm font-medium text-gray-light-900" role="status">
        Demande transmise : notre équipe vous envoie une nouvelle proposition.
      </p>
    )
  }

  return (
    <Button
      className="gap-1.5 bg-brand-600 text-white hover:bg-brand-700"
      disabled={request.isPending}
      onClick={request.send}
    >
      <CopyPlus className="size-4" />
      Je souhaite recevoir un devis similaire
    </Button>
  )
}
